import React from 'react'

const ContactTitle = () => {
  return (
    <div className='relative font-["Open_sans"] font-black text-white text-center md:text-end  '>
      <div className='opacity-80 animate__animated animate__slideInDown md:max-w-[1060px] mx-auto'>


          <div className='md:hidden text-[105px] leading-[80%]'>
            <p> 
                HELLO!
            </p>
          </div>
          <div className='hidden md:inline  lg:hidden text-center text-[200px] leading-[80%]'>
            <p> 
                HELLO!
            </p>
   
          </div>
          <div className='hidden lg:flex flex-col tracking-[33.5px] text-center text-[203px] leading-[90%]'>
            <p className=''> 
                SAY HI!
            </p>

            </div>
          </div>



    </div>
  )
}

export default ContactTitle
